import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import classNames from 'classnames';
import _ from 'lodash';
import Translate from 'translate';

import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import IncmsService from 'services/IncmsService';
import DeleteModal from 'components/HTMLElements/DeleteModal';
import { Checkbox, FormGroup, Text, Textarea, Select } from 'components/FormElements/';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import { required, validPhone } from 'constants/InputErrors';

class SendServicesModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      deleteModalOpened: false,
      editMode: false,
      entity: {},
      types: []
    };

    this.deleteService = this.deleteService.bind( this );
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
    this.toggleDeleteModal = this.toggleDeleteModal.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if ( nextProps.open && !this.props.open ) {
      this.getTypes();
      if ( this.state.editMode ) this.setState( { editMode: false } )
    }
  }

  deleteService() {
    this.props.toggleLoading( true );

    IncmsService.deleteSendService( this.entityToDelete ).then( ( response ) => {
      this.props.toggleLoading( false );
      if ( response.errors ) return this.props.toggleAlertError( response.errors );

      this.getData( this.params );
      if ( this.props.confirmDelete ) this.setState( { deleteModalOpened: false } )
    } )
  }

  getTypes() {
    IncmsService.getSendServiceTypes().then( response => {
      if ( response.data ) this.setState( { types: response.data } )
    } )
  }

  getData( params ) {
    const { activeAccount, toggleLoading } = this.props;
    this.params = params;

    if( activeAccount ) {
      this.props.toggleLoading( true );

      const apiParams = {
        limit: params.pageSize,
        offset: (params.page * params.pageSize) + 1,
      };
      if ( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';

      IncmsService.getSendServices( activeAccount.account, apiParams ).then( ( response ) => {
        if ( response.data ) {
          this.setState( {
            data: response.data.data || [],
            pages: Math.ceil( response.data.total / params.pageSize ),
            total: response.data.total,
          }, () => toggleLoading( false ) );
        } else {
          toggleLoading( false )
        }
      } )
    }
  }

  submitForm( data ) {
    const { activeAccount, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );
    console.log(activeAccount);
    if( activeAccount ) {
      toggleLoading( true );

      const promise = data.idSendService ? IncmsService.updateSendService( activeAccount.id, data ) :
        IncmsService.saveSendService( activeAccount.id, data );

      promise.then( ( response ) => {
        toggleLoading( false );
        if ( response.errors ) return toggleAlertError( response.errors );
        this.toggleEdit()
      } )
    }
  }

  toggleDeleteModal( entityId ) {
    this.entityToDelete = entityId;

    if ( this.props.confirmDelete ) return this.setState( { deleteModalOpened: !this.state.deleteModalOpened } );
    this.deleteService()
  };

  toggleEdit( entity ) {
    this.formData = null;
    this.setState( { editMode: !this.state.editMode, entity } );
  }

  updateMainService( entity ) {
    this.props.toggleLoading( true );

    IncmsService.updateMainSendService( {
      idAccount: entity.idAccount,
      idSendService: entity.idSendService,
    } ).then( ( response ) => {
      this.props.toggleLoading( false );
      if ( response.errors ) return this.props.toggleAlertError( response.errors );

      this.getData( this.params )
    } )
  }

  render() {
    const { confirmDelete, onClose, open, externalCustomer } = this.props;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName={this.state.editMode ? 'col-md-6' : 'col-md-10 max-width-unset'}
             open={open}
             onClose={() => {
               this.setState( { data: [] } );
               onClose()
             }}>
        <div className="row mb-2">
          <div className="col-md-11 pr-0 d-flex align-items-center justify-content-between">
            <h5 className="m-0 d-inline-block"><Translate id="sendServices"/></h5>
            {!this.state.editMode &&
            <button className="btn btn-info" onClick={() => this.toggleEdit()}><Translate
              id="createSendServices"/></button>
            }
          </div>
        </div>

        {this.state.editMode ?
          <Form defaultValues={this.formData || this.state.entity}
                onSubmit={this.submitForm}
                validate={( values ) => {
                  return {
                    destinationName: required( values.destinationName ),
                    sendServiceType: required( values.sendServiceType ),
                    poBox: values.sendServiceType === 'MOENV00001' ? required( externalCustomer === 'apu' ? values.address : values.poBox ) : null,
                    phone: values.sendServiceType === 'MOENV00006' ?
                      required( values.phone ) ? required( values.phone ) : validPhone(values.phone) : null,
                    email: values.sendServiceType === 'MOENV00004' ? required( values.email ) : null,
                  }
                }}>
            {( { getValue, submitForm } ) =>
              <form onSubmit={submitForm}>
                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="name"/></label>
                    <Text field="destinationName" className="form-control"/>
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="type"/></label>
                    <Select field="sendServiceType" className="form-control" placeholder=""
                            valueKey="codDevelop" labelKey="nameType"
                            options={this.state.types}/>
                  </FormGroup>

                  {getValue( 'sendServiceType' ) === 'MOENV00001' &&
                  <FormGroup containerClass="col-md-6">
                    { externalCustomer === 'apu' ? 
                      <div>
                        <label><Translate id="address"/></label>
                        <Text field="address" className="form-control"/>
                      </div>
                      :
                      <div>
                        <label>PO Box</label>
                        <Text field="poBox" className="form-control"/>
                      </div>
                    }
                  </FormGroup>
                  }

                  {getValue( 'sendServiceType' ) === 'MOENV00006' &&
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="phoneNumber"/></label>
                    <Text field="phone" className="form-control" placeholder="+254XXXXXXXXX"/>
                  </FormGroup>
                  }

                  {getValue( 'sendServiceType' ) === 'MOENV00004' &&
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="email"/></label>
                    <Text field="email" className="form-control"/>
                  </FormGroup>
                  }
                </div>

                <div className="text-right">
                  <button type="button" className="btn btn-outline-secondary px-4 mr-2"
                          onClick={() => this.toggleEdit()}>
                    <Translate id="cancel"/>
                  </button>
                  <button className="btn btn-info"><Translate id="submit"/></button>
                </div>
              </form>
            }
          </Form>
          :
          <AsyncTable className="app-table-white"
                      onFetchData={this.getData}
                      rowsText={<Translate id="services"/>}
                      showPageSizeOptions={false}
                      {...this.state}
                      columns={[
                        {
                          Header: <Translate id="destinationName"/>,
                          accessor: 'destinationName'
                        },
                        {
                          Header: <Translate id="deliveryMethod"/>,
                          accessor: 'sendServiceTypeName'
                        },
                        { Header: <Translate id="email"/>, accessor: 'email' },
                        { Header: <Translate id="phone"/>, accessor: 'phone' },
                        { Header: <Translate id="address"/>, accessor: 'address'},
                        {
                          Header: '', accessor: 'idSendService',
                          maxWidth: 120,
                          Cell: props =>
                            <div>
                              <button className="btn btn-outline-info btn-sm"
                                      onClick={() => this.toggleEdit( props.original )}>
                                <i className="fa fa-edit"/>
                              </button>
                              {externalCustomer !== 'apu' &&
                                <button className="btn btn-outline-danger btn-sm mx-2"
                                        onClick={() => this.toggleDeleteModal( props.value )}>
                                  <i className="fa fa-trash"/>
                                </button>
                              }
                              {externalCustomer !== 'apu' &&
                                <button className="btn btn-outline-warning btn-sm" disabled
                                        onClick={() => this.updateMainService( props.original )}>
                                  <i className={classNames( 'fa', {
                                    'fa-star-o': !props.original.indPrincipal,
                                    'fa-star': props.original.indPrincipal,
                                  } )}/>
                                </button>
                              }
                            </div>
                        },
                      ]}
          />
        }

        {confirmDelete &&
        <DeleteModal onConfirm={this.deleteService}
                     opened={this.state.deleteModalOpened}
                     onToggle={this.toggleDeleteModal}
        />
        }
      </Modal>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ({
  activeAccount: state.channelDetail.activeAccount,
  confirmDelete: state.user.beforeDelete,
  externalCustomer: state.settings.externalCustomer,

});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( SendServicesModal );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/SendServicesModal/index.js